<template>
    <div class="password-restore">
        <v-layout row wrap justify-center>
            <v-flex xs12 md8 lg6>
                <v-card>
                    <v-card-title primary-title class="text_navbar">
                        <span class="white--text headline font-weight-medium hidden-sm-and-down">
                            Восстановление пароля
                        </span>
                        <span class="white--text subheading font-weight-medium hidden-md-and-up">
                            Восстановление пароля
                        </span>
                    </v-card-title>
                    <v-form ref="form" v-model="valid" lazy-validation>
                        <v-card-text>
                            <v-container grid-list-md fluid>
                                <v-alert v-if="is_confirm_form"
                                        :value="true" outline type="info" color="secondary">
                                    <p>Придумайте новый пароль.</p>
                                    <p>Пароль должен быть от 8 до 25 символов, с использованием
                                        букв латинского алфавита содержать как минимум одну цифру.</p>
                                </v-alert>
                                <v-layout row wrap justify-center>
                                    <v-flex xs12 md8>
                                        <template v-if="!is_confirm_form">
                                            <v-text-field
                                                    v-model="restore_email" color="accent"
                                                    :rules="rules.email"
                                                    hint="Ваш e-mail, привязанный к учетной записи"
                                                    placeholder="example@contoso.com"
                                                    label="E-Mail" required
                                            ></v-text-field>
                                        </template>
                                        <template v-else>
                                            <v-text-field :append-icon="show_password ? 'visibility_off' : 'visibility'"
                                                          @click:append="show_password = !show_password"
                                                          v-model="confirm_pass1" color="accent"
                                                          :type="show_password ? 'text' : 'password'"
                                                          :rules="rules.password" hint="Ваш новый пароль"
                                                          label="Пароль" counter required
                                            ></v-text-field>
                                            <v-text-field v-if="!show_password"
                                                          v-model="confirm_pass2" color="accent"
                                                          type="password"
                                                          :rules="rules.password"
                                                          hint="Повторно введите ваш новый пароль"
                                                          label="Подтвердите пароль" counter required
                                            ></v-text-field>
                                        </template>
                                    </v-flex>
                                    <v-flex xs12>
                                        <v-alert outline :value="alert_show" :type="alert_color">
                                            <p v-for="txt in alert_text" v-bind:key="alert_text.indexOf(txt)" style="margin-bottom: 0px;">{{txt}}</p>
                                        </v-alert>
                                    </v-flex>
                               </v-layout>
                            </v-container>
                        </v-card-text>
                        <v-card-actions class="bg_navbar">
                            <v-container class="mx-2 pa-1" fluid>
                                <v-layout wrap pa-1 align-center justify-center column fill-height>
                                    <v-flex>
                                        <vue-recaptcha class="hidden-xs-only"
                                                       theme="light" size="normal"
                                                       ref="recaptcha"
                                                       @verify="onVerify"
                                                       @expired="onExpired"
                                                       :sitekey="sitekey">
                                        </vue-recaptcha>
                                        <vue-recaptcha class="hidden-sm-and-up"
                                                       theme="light" size="compact"
                                                       ref="recaptcha"
                                                       @verify="onVerify"
                                                       @expired="onExpired"
                                                       :sitekey="sitekey">
                                        </vue-recaptcha>
                                        <br />
                                        <v-btn block large color="success" fill-height
                                               :disabled="!valid || !recaptcha" @click="validate"
                                        :loading="request_loading">
                                            <span class="subheading font-weight-medium">Отправить</span>
                                            <v-icon right medium>send</v-icon>
                                        </v-btn>
                                    </v-flex>
                                </v-layout>
                            </v-container>
                        </v-card-actions>
                    </v-form>
                </v-card>
            </v-flex>
        </v-layout>
        <v-snackbar v-model="snack" :timeout="10000" :color="snackColor">
            {{ snackText }}
            <v-btn flat @click="snack = false" :ripple="false">Закрыть</v-btn>
        </v-snackbar>
    </div>
</template>

<script>
    import $ from 'jquery';
    import VueRecaptcha from 'vue-recaptcha';
    import {Globals} from '@/globals.js';

    export default {
        name: "PasswordRestore",
        data(){
            return {
                // Form - RESTORE
                restore_email: '',
                // Form - CONFIRM
                confirm_pass1: '',
                confirm_pass2: '',
                show_password: false,
                // Validate
                valid: false,
                recaptcha: false,
                recaptcha_validation: '',
                sitekey: Globals.RECAPTCHA_SITE_KEY,
                // Options
                is_confirm_form: false,
                payload_uid: '',
                payload_token: '',
                request_loading: false,
                // Alerts
                alert_show: false,
                alert_color: 'error',
                alert_text: [],
                // Snack
                snack: false,
                snackColor: '',
                snackText: '',
                // Rules
                rules: {
                    required: [
                        v => !!v || 'Это поле обязательно для заполнения',
                    ],
                    password: [
                        v => !!v || 'Это поле обязательно для заполнения',
                        v => (v && v.length <= 25) || 'Не более 25 символов',
                        v => (v && v.length >= 8) || 'Не менее 8 символов'
                    ],
                    email: [
                        v => !!v || 'Это поле обязательно для заполнения',
                        v => /.+@.+/.test(v) || 'Некоректный E-mail'
                    ],
                },
            }
        },
        created() {
            this.payload_uid = this.$route.query.uid;
            this.payload_token = this.$route.query.token;
            if (this.payload_uid && this.payload_token)
                if (this.payload_uid !== '' && this.payload_token != '')
                    this.is_confirm_form = true;
        },
        components: {
            VueRecaptcha,
        },
        methods: {
            // Request
            send_request(email, validation) {
                if(!validation || validation === '') {
                    this.show_alert('error', 'Invalid ReCaptcha. Please reload form and try again.')
                    return;
                }
                this.request_loading = true;
                $.ajax({
                    url: '' + Globals.API.ROOT + Globals.API.AUTH + 'password/reset/',
                    type: 'POST',
                    data: {
                        email: email,
                    },
                    success: () => {
                        this.show_alert('success', ['Запрос отправлен.',
                            'В ближайшее время вы получите письмо от price-mailbot@sibdt.com с инструкцией по восстановлению пароля.',
                            'Если вы не получили письмо, пожалуйста проверьте вашу папку со спамом, попробуйте отправить запрос еще раз или напишите нам на service@sibdt.com'])
                        this.show_snack('success', 'Запрос отправлен');
                    },
                    error: (response) => {
                        if(response.responseJSON.email)
                            this.show_alert('error', ['Произошла ошибка: ' + response.responseJSON.email])
                        else
                            this.show_alert('error', ['Произошла ошибка: ' + response.responseText])
                        this.show_snack('error', 'Ошибка при выполнении запроса');
                    },
                    complete: () => {
                        this.resetForm();
                    },
                })
            },
            send_confirm(pass1, pass2, validation, confirm_uid, confirm_token) {
                if(!validation || validation === '') {
                    this.show_alert('error', 'Invalid ReCaptcha. Please reload form and try again.')
                    return;
                }
                if (this.show_password)
                    pass2 = pass1;
                if (pass1 !== pass2){
                    this.show_alert('warning', ['Пароли не совпадают!']);
                    return;
                }
                this.request_loading = true;
                $.ajax({
                    url: '' + Globals.API.ROOT + Globals.API.AUTH + 'password/reset/confirm/',
                    type: 'POST',
                    data: {
                        uid: confirm_uid,
                        token: confirm_token,
                        new_password: pass1,
                    },
                    success: () => {
                        this.show_alert('success', ['Новый пароль установлен.']);
                        this.show_snack('success', 'Пароль изменен');
                    },
                    error: (response) => {
                        if(response.responseJSON.new_password)
                            this.show_alert('error', ['Произошла ошибка: ' + response.responseJSON.new_password])
                        else if(response.responseJSON.non_field_errors)
                            this.show_alert('error', ['Произошла ошибка: ' + response.responseJSON.non_field_errors])
                        else
                            this.show_alert('error', ['Произошла ошибка: ' + response.responseText])
                        this.show_snack('error', 'Ошибка при выполнении запроса');
                    },
                    complete: () => {
                        this.resetForm();
                    },
                })
            },
            // Validation
            validate() {
                if (this.$refs.form.validate() && this.recaptcha) {
                    if (this.is_confirm_form)
                        this.send_confirm(this.confirm_pass1, this.confirm_pass2,
                            this.recaptcha_validation, this.payload_uid, this.payload_token)
                    else
                        this.send_request(this.restore_email, this.recaptcha_validation)
                }
            },
            // RE-Captcha
            onVerify: function (response) {
                //console.log('Verify: ' + response);
                this.recaptcha_validation = response;
                this.recaptcha = true;
            },
            onExpired: function () {
                //console.log('Expired')
                this.recaptcha_validation = '';
                this.recaptcha = false;
            },
            resetRecaptcha() {
                this.recaptcha = false;
                this.recaptcha_validation = '';
                this.$refs.recaptcha.reset() // Direct call reset method
            },
            // Form Reset
            resetForm() {
                this.$refs.form.reset();
                this.resetRecaptcha();
            },
            // Alert
            show_alert(alert_type, alert_message){
                this.request_loading = false;
                this.alert_show = true;
                this.alert_color = alert_type;
                this.alert_text = alert_message;
            },
            // Form MISC
            show_snack(snack_color, snack_text){
                this.snack = true;
                this.snackColor = snack_color;
                this.snackText = snack_text;
            }
        },
    }
</script>

<style scoped>

</style>
